const { getDate } = require('./getDate')
const { addSubDays } = require('./addSubDays')

/**
 * Egy adott dátumból kivon/hozzáad egy adott mennyiségű napot.
 * @param {string} date - A dátum amiből ki akarunk vonni.
 * @param {'+' | '-'} operation - Milyen operációt szeretnénk végrehajtani a dátumon.
 * @param {number} dayCount - Azon napok száma, ahány napot szeretnénk kivonni.
 * @returns {string} A módosított dátum.
 */
module.exports.addSubDaysDate = function addSubDaysDate (date, operation, dayCount) {
  return getDate(addSubDays(date, operation, dayCount))
}
